import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import {
  QuestionHistoryModal,
  QuestionLibraryTemplate,
  QuestionPreviewModal,
  useQuestionDelete,
  useQuestionLibrary,
} from '@/features/question-library';

export const Route = createFileRoute('/_authenticated/question-library/')({
  component: QuestionLibraryPage,
});

function QuestionLibraryPage() {
  const navigate = useNavigate();
  const {
    data,
    isLoading,
    totalCount,
    currentPage,
    totalPages,
    filters,
    disciplineOptions,
    authorOptions,
    companyOptions,
    componentTypeOptions,
    isDisciplineQuerySuccess,
    updateFilters,
    resetFilters,
    setDisciplineSearch,
  } = useQuestionLibrary();

  const { mutate: deleteQuestion } = useQuestionDelete();

  const [previewId, setPreviewId] = useState<string | null>(null);
  const [historyId, setHistoryId] = useState<string | null>(null);

  return (
    <>
      <QuestionLibraryTemplate
        totalCount={totalCount}
        tableProps={{
          data,
          isLoading,
          totalCount,
          currentPage,
          totalPages,
          onPageChange: page => updateFilters({ page }),
          onEdit: id =>
            void navigate({ to: '/question-library/$questionId', params: { questionId: id } }),
          onDelete: id => deleteQuestion({ id: Number(id) }),
          onPreview: id => setPreviewId(id),
          onHistory: id => setHistoryId(id),
        }}
        filterProps={{
          filters,
          disciplineOptions,
          authorOptions,
          companyOptions,
          componentTypeOptions,
          onFiltersChange: updateFilters,
          onSearch: () => updateFilters({ page: 1 }),
          onClear: resetFilters,
          onDisciplineSearchChange: setDisciplineSearch,
          isDisciplineQuerySuccess,
        }}
        onAddQuestion={() => void navigate({ to: '/question-library/new' })}
      />

      <QuestionPreviewModal questionId={previewId} onClose={() => setPreviewId(null)} />

      <QuestionHistoryModal questionId={historyId} onClose={() => setHistoryId(null)} />
    </>
  );
}
